







import { Component, Vue, Prop} from 'vue-property-decorator';

@Component({})
export default class ChatInfo extends Vue{
  private time = ''
  private message = ''
}
